import { Locale } from "@/Common/Models/Localization/Locale";
import { ObstetricalResourcesTaceScreening } from "@/Patient/Models/ObstetricalFile/Resources/ObstetricalResourcesTaceScreening";
import { BaseObstetricalFileSubSection, BaseObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseObstetricalFileSubSection";
import { ObstetricalFileResourcesQuestionnaireTable } from "./ObstetricalFileResourcesQuestionnaireTable";
import { ObstetricalResourcesAnxietyScreeningSectionState } from "./ObstetricalResourcesAnxietyScreeningSection";

interface ObstetricalResourcesTAceScreeningSectionProps<TForm> extends BaseObstetricalFileSubSectionProps<TForm> {
    model: ObstetricalResourcesTaceScreening;
    mutateTAceScreeningStateWithFormUpdate: (mutation: (state: ObstetricalResourcesTaceScreening) => void) => void;
    className?: string;
    normalTextSubtitle?: boolean;
}

class ObstetricalResourcesTAceScreeningSection<TForm> extends BaseObstetricalFileSubSection<TForm, ObstetricalResourcesTAceScreeningSectionProps<TForm>, ObstetricalResourcesAnxietyScreeningSectionState> {
    public componentDidMount(): void {
        this.setAcceptableLocales([Locale.en]);
    }

    public render(): JSX.Element {
        const model = this.props.model;
        const alternateAnswerLabels = {
            [0]: "ObstetricalFile_NoEqual0Label",
            [1]: "ObstetricalFile_YesEqual1Label"
        };

        return (
            <div className={this.props.className ?? ""}>
                <div className="row">
                    <div className="col-md-12">
                        <ObstetricalFileResourcesQuestionnaireTable
                            id="TaceScreeningQuestionnaire"
                            title="ObstetricalFile_TAceScreeningToolLabel"
                            subTitle="ObstetricalFile_TAce1DrinkEquivalentToLabel"
                            extraSubTitle={(
                                <p className={`flex-display flex-col-gap-md ${this.props.normalTextSubtitle ? "" : "f16px"}`}>
                                    <span>- {this.getString("ObstetricalFile_TAce12OzOfBeerLabel")}</span>
                                    <span>- {this.getString("ObstetricalFile_TAce12OzOfCoolerLabel")}</span>
                                    <span>- {this.getString("ObstetricalFile_TAce5OzOfWineLabel")}</span>
                                    <span>- {this.getString("ObstetricalFile_TAceMixedDrinkLabel")}</span>
                                </p>
                            )}
                            readonly={this.props.readonly}
                            date={model.TaceScreeningDate}
                            onDateChange={date => this.props.mutateTAceScreeningStateWithFormUpdate(s => s.TaceScreeningDate = date)}
                            hideHeader
                            columns={[
                                { label: "ObstetricalFile_LessThan2DrinksLabel", pointValue: 0 },
                                { label: "ObstetricalFile_MoreThan2DrinksLabel", pointValue: 1 }
                            ]}
                            columnClassName="t-ace-answercolumn-width"
                            questions={[
                                {
                                    questionLabel: "ObstetricalFile_TAceNumberOfDrinkToFeelHighLabel",
                                    onClick: value => this.props.mutateTAceScreeningStateWithFormUpdate(s => s.NumberOfDrinksScore = value),
                                    value: model.NumberOfDrinksScore,
                                    alternateAnswerLabels: {
                                        [0]: "ObstetricalFile_LessThan2DrinksLabel",
                                        [1]: "ObstetricalFile_MoreThan2DrinksLabel"
                                    }
                                },
                                {
                                    questionLabel: "ObstetricalFile_TAceAnnoyedForDrinkinglLabel",
                                    onClick: value => this.props.mutateTAceScreeningStateWithFormUpdate(s => s.AnnoyedByPeopleScore = value),
                                    value: model.AnnoyedByPeopleScore,
                                    alternateAnswerLabels: alternateAnswerLabels
                                },
                                {
                                    questionLabel: "ObstetricalFile_TAceCutDownDrinklLabel",
                                    onClick: value => this.props.mutateTAceScreeningStateWithFormUpdate(s => s.CutDownDrinkingScore = value),
                                    value: model.CutDownDrinkingScore,
                                    alternateAnswerLabels: alternateAnswerLabels
                                },
                                {
                                    questionLabel: "ObstetricalFile_TAceDrinkMorninglLabel",
                                    onClick: value => this.props.mutateTAceScreeningStateWithFormUpdate(s => s.MorningDrinkScore = value),
                                    value: model.MorningDrinkScore,
                                    alternateAnswerLabels: alternateAnswerLabels
                                }
                            ]}
                            totalScore={model.TotalScore}
                            scoreDescription={{
                                titleLabel: "ObstetricalFile_TAceTotalScoreDescriptionLabel"
                            }}
                            normalTextSubtitle={this.props.normalTextSubtitle}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export { ObstetricalResourcesTAceScreeningSection };
